<template>
	<div class="container-fluid dashboard-wrapper">
		<div class="row">
			<div class="col-lg-12 mb-3">
				<div class="d-flex align-items-center justify-content-between welcome-content">
					<div class="navbar-breadcrumb">
						<h4 class="mb-0 font-weight-700">Welcome to Dashboard!</h4>
					</div>
				</div>
			</div>
			<div class="col-lg-12">
				<div class="row">
					<div class="col-lg-3 col-md-6">
						<div class="card card-block card-stretch card-height">
							<div class="card-body">
								<div class="d-flex align-items-center justify-content-between">
									<div class="mm-cart-image text-danger">
										<svg class="svg-icon svg-danger mr-4" id="h-01" width="50" height="52" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
											<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
										</svg>
									</div>
									<div class="mm-cart-text">
										<h2 class="font-weight-700">{{ users_count }}</h2>
										<p class="mb-0 text-danger">Users</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-6">
						<div class="card card-block card-stretch card-height">
							<div class="card-body">
								<div class="d-flex align-items-center justify-content-between">
									<div class="mm-cart-image text-success">
										<svg class="svg-icon svg-success mr-4" width="50" height="52" id="h-02" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
											<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
										</svg>
									</div>
									<div class="mm-cart-text">
										<h2 class="font-weight-700">{{ vehicles_count }}</h2>
										<p class="mb-0 text-success">Vehicles</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-6">
						<div class="card card-block card-stretch card-height">
							<div class="card-body">
								<div class="d-flex align-items-center justify-content-between">
									<div class="mm-cart-image text-primary">
										<svg class="svg-icon svg-blue mr-4" id="h-03" width="50" height="52" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
											<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"></path>
										</svg>
									</div>
									<div class="mm-cart-text">
										<h2 class="font-weight-700">{{ spare_count }}</h2>
										<p class="mb-0 text-primary">Spare Parts</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-6">
						<div class="card card-block card-stretch card-height">
							<div class="card-body">
								<div class="d-flex align-items-center justify-content-between">
									<div class="mm-cart-image text-warning">
										<svg class="svg-icon svg-warning mr-4" id="h-04" width="50" height="52" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
											<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
										</svg>
									</div>
									<div class="mm-cart-text">
										<h2 class="font-weight-700">{{ brands_count }}</h2>
										<p class="mb-0 text-warning">Brands</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-12">
				<div class="row">
					<div class="col-lg-4 col-md-6">
						<div class="card card-block card-stretch card-height">
							<div class="card-header d-flex justify-content-between">
								<div class="header-title">
									<h6 class="card-title">Latest Vehicles</h6>
								</div>
								<div class="card-header-toolbar d-flex align-items-center">
									<router-link :to="{name: 'vehicles.view'}" class="btn btn-sm btn-outline-primary view-more">View All Vehicles</router-link>									
								</div>
							</div>
							<div class="card-body">
								<ul class="list-inline p-0">
									<li class="media align-items-center mb-3" v-for="vehic in vehicles" :key="vehic.id">
										<router-link :to="{name: 'vehicles.show', params: { id: vehic.id }}"  v-if="vehic.image">
											<img v-bind:src="$image_url + vehic.image" class="img-fluid avatar-60 rounded-small" alt="image"/>
										</router-link>
										<router-link :to="{name: 'vehicles.show', params: { id: vehic.id }}" v-else>
											<img src="@/assets/images/layouts/layout-1/prod-1.jpg" class="img-fluid avatar-60 rounded-small" alt="image"/>
										</router-link>
										<div class="media-body ml-3">
											<h6>{{ vehic.title | excerpt(20) }}</h6>
											<p class="mb-0 text-primary">{{ vehic.location }}</p>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-6">
						<div class="card card-block card-stretch card-height rule-box">
							<div class="card-header d-flex justify-content-between">
								<div class="header-title">
									<h6 class="card-title">Spare Parts</h6>
								</div>
								<div class="card-header-toolbar d-flex align-items-center">
									<router-link :to="{name: 'accessories.view'}" class="btn btn-sm btn-outline-primary view-more">View All Spare Parts</router-link>	
								</div>
							</div>
							<div class="card-body">
								<ul class="perfomer-lists m-0 p-0">
									<li class="media align-items-center mb-3" v-for="spare in spares" :key="spare.id">

										<router-link :to="{name: 'accessories.show', params: { id: spare.id }}"  v-if="spare.image">
											<img v-bind:src="$image_url + spare.image" class="img-fluid avatar-60 rounded-small" alt="image"/>
										</router-link>
										<router-link :to="{name: 'accessories.show', params: { id: spare.id }}" v-else>
											<img src="@/assets/images/layouts/layout-1/prod-1.jpg" class="img-fluid avatar-60 rounded-small" alt="image"/>
										</router-link>

										<div class="media-body ml-3">
											<h6>{{ spare.title | excerpt(20)  }}</h6>
											<p class="mb-0 text-primary">{{ spare.location }}</p>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-lg-4">
						<div class="card card-block card-stretch card-height">
							<div class="card-header d-flex justify-content-between">
								<div class="header-title">
									<h6 class="card-title">New Users</h6>
								</div>
								<div class="card-header-toolbar d-flex align-items-center">	
									<router-link :to="{name: 'users.view'}" class="btn btn-sm btn-outline-primary view-more">View All Users</router-link>
								</div>
							</div>
							<div class="card-body">
								<ul class="list-inline p-0 m-0">
									<li class="media align-items-center mb-3" v-for="user in users" :key="user.id">

										<router-link :to="{name: 'users.show', params: { id: user.id }}"  v-if="user.image">
											<img v-bind:src="$image_url + user.image" class="img-fluid avatar-60 rounded-small" alt="image"/>
										</router-link>

										<router-link :to="{name: 'users.show', params: { id: user.id }}" v-else>
											<img src="@/assets/images/layouts/layout-1/prod-1.jpg" class="img-fluid avatar-60 rounded-small" alt="image"/>
										</router-link>

										<div class="media-body ml-3">
											<h6>{{ user.name }}</h6>
											<p class="mb-0 text-primary" v-if="user.email">{{ user.email }}</p>
											<p class="mb-0 text-primary" v-else>{{ user.country_code + user.phone_number }}</p>
											<p class="mb-0">{{user.created_at | formatDateTime}}</p>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Page end  -->
	</div>
</template>
<script>
	export default {
		name: "Dashbord1",
		components: {},
		data() {
			return {
				users_count: null,
				vehicles_count: null,
				spare_count: null,
				brands_count: null,
				users: null,
				vehicles: null,
				spares: null,
			};
		},
		created() {
			this.fetchDashboard();
		},
		methods: {
			fetchDashboard(page_url = null) {
				let url = "/api/admin/dashboard";
				page_url = page_url || url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.users_count = responseData.user_count;
						this.vehicles_count = responseData.vehicle_count;
						this.spare_count = responseData.spare_parts_count;
						this.brands_count = responseData.brands_count;

						this.users = responseData.users;
						this.vehicles = responseData.vehicles;
						this.spares = responseData.accessories;

						console.log(responseData);
					})
					.catch((err) => console.log(err));
			},
			
			getToken() {
				if (localStorage.token) {
					this.token = localStorage.token;
				} else {
					this.$vToastify.error("Session expired, please login again");
					this.$router.push({ name: "auth.login" });
				}
			},
		},
	};
</script>
